import { FormOutlined } from '@ant-design/icons-vue';
import PurchaseRequirementSettings from '@/views/products/PurchaseRequirementSettings.vue';
import ContractSignatures from '@/views/products/ContractSignatures.vue';

export const formsFolderRoute = {
    path: 'forms',
    name: 'Forms',
    redirect: { name: 'FormActivities' },
    meta: {
        title: '表單管理',
        icon: FormOutlined
    },
    children: []
};

/** 報名 → 同意／契約 → 題庫 → 表單 → 審核 */
export const formsChildrenRoutes = [
    {
        path: 'form-activities',
        component: () => import('@/views/forms/FormActivities.vue'),
        name: 'FormActivities',
        meta: {
            title: '報名活動管理'
        }
    },
    {
        path: 'purchase-requirements',
        component: PurchaseRequirementSettings,
        name: 'PurchaseRequirementSettings',
        meta: {
            title: '同意與契約設定',
            description: '商品購買與課程報名共用的同意條款、契約模板'
        }
    },
    {
        path: 'contract-signatures',
        component: ContractSignatures,
        name: 'ContractSignatures',
        meta: {
            title: '契約簽署紀錄',
            description: '會員購物或課程報名時的同意與簽署紀錄'
        }
    },
    {
        path: 'form-topics',
        component: () => import('@/views/forms/FormTopics.vue'),
        name: 'FormTopics',
        meta: {
            title: '題庫管理'
        }
    },
    {
        path: 'forms-management',
        component: () => import('@/views/forms/FormsManagement.vue'),
        name: 'FormsManagement',
        meta: {
            title: '表單列表'
        }
    },
    {
        path: 'form-cancellation-requests',
        component: () => import('@/views/forms/FormCancellationRequests.vue'),
        name: 'FormCancellationRequests',
        meta: {
            title: '報名取消審核'
        }
    },
    {
        path: 'forms-create',
        component: () => import('@/views/forms/FormEdit.vue'),
        name: 'FormsCreate',
        meta: {
            title: '新增表單',
            hidden: true
        }
    },
    {
        path: 'forms-edit/:id',
        component: () => import('@/views/forms/FormEdit.vue'),
        name: 'FormsEdit',
        meta: {
            title: '編輯表單',
            hidden: true
        }
    },
    {
        path: 'forms-view/:id',
        component: () => import('@/views/forms/FormView.vue'),
        name: 'FormsView',
        meta: {
            title: '表單詳情',
            hidden: true
        }
    }
];

/** 舊營運頁併入表單詳情，保留路由名稱供權限與 redirect */
export const formsLegacyRoutes = [
    {
        path: '/form-activities',
        redirect: { name: 'FormActivities' },
        meta: { hidden: true }
    },
    {
        path: '/course-paths',
        redirect: '/platform/course-paths',
        meta: { hidden: true }
    },
    {
        path: '/forms/course-paths',
        redirect: '/platform/course-paths',
        meta: { hidden: true }
    },
    {
        path: '/form-topics',
        redirect: { name: 'FormTopics' },
        meta: { hidden: true }
    },
    {
        path: '/forms-management',
        redirect: { name: 'FormsManagement' },
        meta: { hidden: true }
    },
    {
        path: '/form-cancellation-requests',
        redirect: { name: 'FormCancellationRequests' },
        meta: { hidden: true }
    },
    {
        path: '/forms-create',
        redirect: { name: 'FormsCreate' },
        meta: { hidden: true }
    },
    {
        path: '/forms-edit/:id',
        redirect: (to) => ({ name: 'FormsEdit', params: to.params }),
        meta: { hidden: true }
    },
    {
        path: '/forms-view/:id',
        redirect: (to) => ({ name: 'FormsView', params: to.params }),
        meta: { hidden: true }
    },
    {
        path: '/forms/purchase-requirements',
        redirect: { name: 'PurchaseRequirementSettings' },
        meta: { hidden: true }
    },
    {
        path: '/forms/contract-signatures',
        redirect: { name: 'ContractSignatures' },
        meta: { hidden: true }
    },
    {
        path: '/products/purchase-requirement-settings',
        redirect: { name: 'PurchaseRequirementSettings' },
        meta: { hidden: true }
    },
    {
        path: '/products/contract-signatures',
        redirect: { name: 'ContractSignatures' },
        meta: { hidden: true }
    },
    {
        path: '/attendee-management',
        redirect: (to) => ({
            name: 'FormsManagement',
            query: { ...to.query, legacy: 'attendees' }
        }),
        name: 'AttendeeManagement',
        meta: { hidden: true }
    },
    {
        path: '/form-submissions',
        redirect: (to) => ({
            name: 'FormsManagement',
            query: { ...to.query, legacy: 'submissions' }
        }),
        name: 'FormSubmissions',
        meta: { hidden: true }
    }
];
